import React from 'react';
import {
    Card,
    CardContent,
    CircularProgress,
    Typography
} from "@mui/joy";

// components
import withNavigate from "../../utils/withNavigate";
import BaseApi from "../../utils/BaseApi";
import withColorScheme from "../../utils/withColorScheme";


class OpportunityCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opportunity: this.props.opportunity?this.props.opportunity:null,
        };
    }

    async componentDidMount() {
        if (!this.state.opportunity) {
            await this.retrieveOpportunity();
        }
    }

    async retrieveOpportunity(){
        const url = `opportunity/${this.props.opportunityId}/`;
        const params = {

        };
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        this.setState(
            {
                opportunity: response.data
            }
        );
    }

    render() {
        if (!this.state.opportunity){
            return(
                <CircularProgress/>
            )
        }
        return(
            <Card>

                <CardContent
                    sx={{
                        justifyContent: 'flex-start',
                    }}
                >
                    <Typography
                        level="h3"
                        // noWrap
                        onClick={() => (this.props.navigate(`/opportunity/detail/${this.state.opportunity.id}`))}
                        sx={{
                            cursor: 'pointer',
                            "&:hover": {
                                color: 'var(--joy-palette-primary-plainColor)',
                            }
                        }}
                    >
                        {this.state.opportunity.title}
                    </Typography>

                </CardContent>
            </Card>
        )
    }
}

export default withNavigate(withColorScheme(OpportunityCard))
